import { observable } from "@legendapp/state";

import { authClient } from "~/libs/auth.lib";
import { syncedCrudPersist } from "../../libs/legend-state";
import type { Organization } from "./organizations.types";

export const organizations$ = observable(
  syncedCrudPersist<Organization>({
    persist: {
      name: "organizations",
    },
  }),
);

/** True once the organizations list has been fetched (empty or not). */
export const organizationsListLoaded$ = observable(false);

authClient.$store.atoms.listOrganizations.subscribe((state) => {
  if (state.data) {
    const organizationsRecord = Object.fromEntries(
      state.data.map((org: Organization) => [org.id, org]),
    );
    organizations$.set(organizationsRecord);
    organizationsListLoaded$.set(true);
  } else if (!state.isPending) {
    organizations$.set({});
    organizationsListLoaded$.set(true);
  }
});
